export default __webpack_public_path__ + "static/media/home-teamworks.5beda839.svg";